import React from 'react';
import { Clock, Zap, Calendar } from 'lucide-react';
import { flexibilityData } from '../mock/programsData';

const icons = [Calendar, Clock, Zap];

const ProgramFlexibility = () => {
  return (
    <section
      id="flexibility"
      data-testid="flexibility-section"
      className="py-16 bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-purple-200 via-pink-200 to-blue-200 rounded-3xl p-8 md:p-12 border-4 border-purple-300 shadow-xl">
          <div className="text-center mb-8">
            <h2 className="text-3xl md:text-4xl font-bold text-purple-700 mb-3">
              {flexibilityData.title}
            </h2>
            <p className="text-base md:text-lg text-purple-800 max-w-3xl mx-auto">
              {flexibilityData.description}
            </p>
          </div>

          <div className="grid sm:grid-cols-3 gap-4 mb-6">
            {flexibilityData.examples.map((ex, i) => {
              const Icon = icons[i % icons.length];
              return (
                <div
                  key={ex}
                  data-testid={`flex-example-${i}`}
                  className="bg-white/70 backdrop-blur-sm border-2 border-white rounded-2xl p-5 text-center hover:bg-white transition-colors duration-300"
                >
                  <div className="w-12 h-12 bg-gradient-to-br from-pink-200 to-purple-200 rounded-2xl flex items-center justify-center mx-auto mb-3">
                    <Icon className="h-6 w-6 text-purple-700" />
                  </div>
                  <p className="font-bold text-purple-800 text-sm">{ex}</p>
                </div>
              );
            })}
          </div>

          <p className="text-center text-purple-800 text-sm md:text-base font-medium italic">
            {flexibilityData.closing}
          </p>
        </div>
      </div>
    </section>
  );
};

export default ProgramFlexibility;
